// @flow
import React from 'react';

import { Card, CardHeader, CardText } from 'material-ui/Card';

import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import Chip from 'material-ui/Chip';

import { cyan50, cyan300 } from 'material-ui/styles/colors';

import {
  DEFAULT_GEOMETRY_FORMAT,
  GEOMETRY_FORMATS,
} from 'utils/geometryFormats';

const styles = {
  infoChip: {
    width: '100%',
    backgroundColor: cyan50,
    whiteSpace: 'wrap',
  },

  infoChipLabel: {
    whiteSpace: 'wrap',
  },

  infoChipAvatar: {
    backgroundColor: cyan300,
    color: 'white',
  },

  subheader: {
    paddingLeft: 0,
  },
};

export default ({ geometryFormat }) => {
  const selectedGeometryFormat =
    geometryFormat !== 'autodetect' ? geometryFormat : DEFAULT_GEOMETRY_FORMAT;

  return (
    <Card>
      <CardHeader
        title="Formátum súgó"
        subtitle="Kattintson ide a súgó megjelenítéséhez"
        actAsExpander
        showExpandableButton
        avatar={
          <FontIcon
            className="material-icons"
            style={{ fontSize: 32, color: cyan300 }}
          >
            help
          </FontIcon>
        }
      />

      <CardText expandable>
        {geometryFormat === 'autodetect' && (
          <Chip style={styles.infoChip} labelStyle={styles.infoChipLabel}>
            <Avatar
              style={styles.infoChipAvatar}
              icon={<FontIcon className="material-icons">info</FontIcon>}
            />
            <strong>Automatikus felismerés aktív:</strong> a súgó az
            alapértelmezett ({GEOMETRY_FORMATS[DEFAULT_GEOMETRY_FORMAT].name})
            formátumra vonatkozik.
          </Chip>
        )}

        <Subheader style={styles.subheader}>Sokszög megadása</Subheader>
        {GEOMETRY_FORMATS[selectedGeometryFormat].polygonalDescription}
        <Divider />

        <Subheader style={styles.subheader}>Kör megadása</Subheader>
        {GEOMETRY_FORMATS[selectedGeometryFormat].circularDescription}
        <Divider />

        {GEOMETRY_FORMATS[selectedGeometryFormat].miscDescription}
      </CardText>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./components/CoordinateInputDialog/FormatHelpCard.js